import { useToggle } from '@brand/utils';
import cn from 'classnames';
import { AngleDownIcon } from 'components/icon/icons';
import { CartPositions as CartPositionsModel } from 'modules/cart/api';
import React, { CSSProperties } from 'react';
import styles from './cart-positions.module.scss';
import { CartPositionItem } from '../../../header-cart';

type TCartPositionsProps = {
  positions: Array<CartPositionsModel>;
};

const MAX_SHOW_POSITIONS = 5;
export const CartPositions = ({
  positions = [],
}: TCartPositionsProps): JSX.Element => {
  const [isOpen, toggle] = useToggle();
  const needToggle = positions.length > MAX_SHOW_POSITIONS;
  return (
    <>
      <div
        className={styles.wrapper}
        style={
          {
            '--total-items':
              isOpen || !needToggle ? positions.length : MAX_SHOW_POSITIONS,
          } as CSSProperties
        }
      >
        {positions.map((position: CartPositionsModel) => (
          <CartPositionItem
            key={position.id}
            position={position}
            className={styles.cartItem}
          />
        ))}
      </div>

      {needToggle && (
        <div className={styles.controllerContainer} onClick={toggle}>
          <div className={cn(styles.controller, { [styles.isOpen]: isOpen })}>
            <AngleDownIcon />
          </div>
        </div>
      )}
    </>
  );
};
